import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
// @ts-expect-error - Swiper CSS 모듈은 타입 정의가 없습니다
import "swiper/css";
// @ts-expect-error - Swiper Pagination CSS 모듈은 타입 정의가 없습니다
import "swiper/css/pagination";
// @ts-expect-error - Swiper Bundle CSS 모듈은 타입 정의가 없습니다
import "swiper/css/bundle";
import { useRef, useEffect } from "react";


export interface SwiperXImgProps {
  data: string[];
  handleSelect?: (seq: string) => void;
}

export const SwiperXImg = ({ data, handleSelect }: SwiperXImgProps) => {
  const swiperRef = useRef<SwiperType | null>(null);
  const totalSlides = data.length + 1;

  // 슬라이드 인덱스에 따라 bullet active 인덱스 결정
  const getActiveBullet = (realIndex: number) => {
    if (realIndex === 0) return 0; // 첫 페이지
    if (realIndex === totalSlides - 1) return 2; // 마지막 페이지
    return 1; // 나머지
  };

  // 슬라이드 변경 시 bullet active 상태 직접 제어
  const handleSlideChange = (swiper: SwiperType) => {
    const bullets = document.querySelectorAll(".swiper-pagination-bullet");
    bullets.forEach(b => b.classList.remove("swiper-pagination-bullet-active"));
    const activeIdx = getActiveBullet(swiper.realIndex);
    if (bullets[activeIdx]) {
      bullets[activeIdx].classList.add("swiper-pagination-bullet-active");
    }
    if (handleSelect) {
      const currentSlide = data[swiper.realIndex];
      handleSelect?.(currentSlide?.toString() || "");
    }
  };

  useEffect(() => {
    // 초기 렌더링 시에도 active bullet 설정
    setTimeout(() => {
      if (swiperRef.current) handleSlideChange(swiperRef.current);
    }, 0);
  }, []);

  return (
    <div className="relative">
      <Swiper
        modules={[Pagination]}
        onSwiper={swiper => (swiperRef.current = swiper)}
        onSlideChange={handleSlideChange}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            if (index > 2) return ""; // 3개까지만 생성
            return `<span class="${className} !bg-gray-200 !w-2 !h-2 !mx-1"></span>`;
          },
          bulletActiveClass: "swiper-pagination-bullet-active",
        }}
        spaceBetween={16}
        slidesPerView={1}
        className="relative [&_.swiper-pagination-bullet]:!transition-none [&_.swiper-pagination-bullet-active]:!bg-yellow"
        style={{ height: "230px", width: "340px" }}
      >
        {data.map((o: string, index: number) => (
          <SwiperSlide key={index}>
            <img
              src={o}
              alt="유치원 이미지"
              className="w-full h-[200px] object-cover rounded-xl"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
